import Vue from "vue";
import VueRouter from "vue-router";
import Vuesax from "vuesax";
import VueTextareaAutosize from "vue-textarea-autosize";
import App from "../components/App.vue";
import "../components/Mixins.js";
import "../assets/css/global.scss";
import "vuesax/dist/vuesax.css";
import "material-icons/iconfont/material-icons.css";

Vue.use(Vuesax);
Vue.use(VueTextareaAutosize);

Vue.use(VueRouter)

const routes = [
	{ path: '/t/0/0-0-0', component: App },
]

const router = new VueRouter({
	routes // short for `routes: routes`
})

new Vue({ el: '#app', router, render: h => h(App) })


// new Vue({
// 	router
// }).$mount('#app')

// new Vue({
// 	el: "#app",
// 	render: h => h(App),
// });
